import React, { FC } from "react";

interface JobRequestDetailBackgroundProps {
  color?: string;
}
export const JobRequestDetailBackground: FC<JobRequestDetailBackgroundProps> = ({ color = "#10273f" }) => (
  <div style={{ backgroundColor: color }} className="job-request-detail__background" />
);
